// Login.jsx
import React from "react";
import { Form, Input, Button, Checkbox } from "antd";
import AuthLayout from "./authlayout";
import brief from "../assets/brief.webp";

export default function Login() {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    // TODO: call your login API
    console.log("Login:", values);
  };

  return (
    <AuthLayout
      imageOnRight={false}
    >
      <div className="brand">
        <div style={{ fontSize: 36, fontWeight: 800 }}>
          <img
            src={brief}
            alt="logo"
            className="brand-logo w-50"
          />
        </div>
       
      </div>

      <h1 className="title">WELCOME BACK</h1>
      <div className="subtitle">Please enter your details.</div>

      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={onFinish}
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Enter your email" },
            { type: "email", message: "Enter a valid email" },
          ]}
        >
          <Input size="large" placeholder="Enter your email" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Enter your password" }]}
        >
          <Input.Password size="large" placeholder="Enter your password" />
        </Form.Item>

        <div className="bottom-row mb-3">
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Remember me</Checkbox>
          </Form.Item>
          <a className="link" href="/forgot-password">
            Forgot password?
          </a>
        </div>

        <Form.Item>
          <Button htmlType="submit" className="btn-deep" block>
            Log In
          </Button>
        </Form.Item>

        <div className="text-center" style={{ color: "#ddd" }}>
          Don’t have an account?{" "}
          <a className="link" href="/register">
            Register here
          </a>
        </div>
      </Form>
    </AuthLayout>
  );
}
